<template>
	<section class="fcm">
		<ManagingSection :is-table="true">
			<template slot="infoSection">
				<div class="section__info__left">
					<p class="fcm__noti">
						* 해당 FCM 토큰 제거시 유저 전체푸쉬를 받을수 없으니
						해당 기능은 유저가 이벤트/알림 설정해제후에도 푸쉬가
						중복으로 올 경우에만 사용해주세요.
					</p>
				</div>
				<div class="section__info__right">
					<button class="btn blue" @click="allSubscribe">
						전체 구독 해제
					</button>
				</div>
			</template>
			<table class="table-main">
				<thead>
					<tr>
						<th>번호</th>
						<th class="fcm__device">디바이스 UUID</th>
						<th class="fcm__token">FCM 토큰</th>
						<th class="fcm__topic">토픽</th>
						<th class="fcm__action">동작</th>
						<th class="fcm__memo">메모</th>
						<th class="fcm__date">생성일시</th>
						<th class="fcm__date">업데이트</th>
						<th class="fcm__button">구독해제</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="list in list" :key="list.id">
						<td>{{ list.id }}</td>
						<td>{{ list.deviceUuid }}</td>
						<td>{{ list.fcmToken }}</td>
						<td>{{ list.topic }}</td>
						<td>
							{{
								list.action === 'subscribe'
									? '구독'
									: '구독해제'
							}}
						</td>
						<td>{{ list.memo }}</td>
						<td>{{ list.formattedDate }}</td>
						<td>{{ list.formattedUpdate }}</td>
						<td>
							<button
								class="btn blue"
								@click="subscribe(list.topic, list.id)"
								:disabled="list.action === 'unsubscribe'"
							>
								구독해제
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</ManagingSection>
	</section>
</template>
<script>
	import moment from 'moment';
	import ManagingSection from '../../components/layout/ManagingSection.vue';
	export default {
		components: {
			ManagingSection,
		},
		data() {
			return {
				list: [],
			};
		},
		mounted() {
			this.load();
		},
		computed: {
			idRegister() {
				return this.$route.params.idRegister;
			},
		},
		methods: {
			async load() {
				try {
					const { data } = await this.$axiosAdmin2.get(
						`/api/registers/${this.idRegister}/fcm-topics`
					);
					this.list = data.map(item => ({
						...item,
						formattedDate: item.createdAt
							? moment(item.createdAt).format(
									'YYYY-MM-DD HH:mm:ss'
								)
							: '',
						formattedUpdate: item.updatedAt
							? moment(item.updatedAt).format(
									'YYYY-MM-DD HH:mm:ss'
								)
							: '',
					}));
				} catch (error) {
					console.error(error);
					alert(
						'데이터를 불러오는 중 에러가 발생했습니다. 지속적인 문제 발생 시 개발팀에 문의해주세요.'
					);
				}
			},
			subscribe(topic, id) {
				const params = {
					fcmTopicIdList: [id],
					memo: `admin에서 ${topic} 구독해제`,
				};
				this.modifySubscribe(params);
			},
			async modifySubscribe(params) {
				try {
					await this.$axiosAdmin2.put(
						`/api/registers/${this.idRegister}/fcm-topic/unsubscribe`,
						params
					);
					alert('구독해제 되었습니다.');
					this.load();
				} catch (error) {
					console.error(error);
					alert(
						'데이터를 불러오는 중 에러가 발생했습니다. 지속적인 문제 발생 시 개발팀에 문의해주세요.'
					);
				}
			},
			allSubscribe() {
				const params = {
					fcmTopicIdList: this.list.map(item => item.id),
					memo: 'admin에서 전체푸쉬 구독해제',
				};
				this.modifySubscribe(params);
			},
		},
	};
</script>
<style lang="scss" scoped>
	.fcm {
		&__noti {
			font-size: 14px;
			margin-top: 20px;
			color: #666;
		}
		&__action {
			width: 10%;
		}
		&__device {
			width: 15%;
		}
		&__memo {
			width: 15%;
		}

		&__topic {
			width: 10%;
		}

		&__date {
			width: 10%;
		}

		&__button {
			width: 130px;
		}
	}
</style>
